import { doGet, doPost } from '../../modules/DataManager';
import { getVisibleManagerIds } from '../../modules/logic/managerScope';
import { usersActions } from '../slices/streamSlices';
import { stripHistory } from '../../modules/utils/stripHistory';

const setUsers = usersActions.set;

export const fetchUsers = () => {
  return async (dispatch) => {
    try {
      const res = await doGet('/v2/users/get-all');
      dispatch(setUsers(res));
    } catch (error) {
      console.error('Error loading users:', error);
    }
  };
};

export const fetchUserById = (id) => {
  return async (dispatch) => {
    try {
      const res = await doGet(`/v2/users/get-user`, { id });
      dispatch(setUsers(res));
    } catch (error) {
      console.error('Error getting user by id:', error);
    }
  };
};

/**
 * Fetch users by filter (backend autocomplete).
 * Expects backend route: GET /v2/users/get-users-by-filter?q=<term>&limitN=<n>
 */
export const fetchUserByFilter = (q, { limitN = 20, company } = {}) => {
  return async (dispatch) => {
    try {
      const params = { q, limitN };
      if (company) params.company = company;
      const res = await doGet(`/v2/users/get-users-by-filter`, params);
      // a seconda di come risponde doGet, prova data/items
      const items = res?.items ?? res?.data?.items ?? res ?? [];
      return items;
    } catch (error) {
      console.error('Error getting user by filter:', error);
      return [];
    }
  };
};

export const createUser = (user) => {
  return async (dispatch) => {
    try {
      const res = await doPost('/v2/users/add-user', user);
      //dispatch(fetchUsers());
    } catch (error) {
      console.error('Error creating user:', error);
    }
  };
};

export const editUser = (user) => {
  return async (dispatch) => {
    try {
      const res = await doPost('/v2/users/edit-user', user);
      //dispatch(fetchUsers());
    } catch (error) {
      console.error('Error editing user:', error);
    }
  };
};

export const deleteUser = (id) => {
  return async (dispatch) => {
    try {
      const res = await doPost('/v2/users/delete-user', { id });
      //dispatch(fetchUsers());
    } catch (error) {
      console.error('Error deleting user:', error);
    }
  };
};

export const getUserById = (id) => {
  return async (dispatch) => {
    try {
      const res = await doGet(`/v2/users/get-user?id=${id}`);
      dispatch(setUsers(res));
    } catch (error) {
      console.error('Error getting user by id:', error);
    }
  };
};

export const startListeningUsers = () => (dispatch, getState) => {
  const firestore = window.firebase.firestore();

  const state = getState();
  const managerId = state.user?.gestore || state.user?.id_gestore;
  const isAdmin =
    state.user?.role?.admin || state.user?.role?.super || state.user?.role?.administrative;

  let query = firestore.collection('rubrica');
  if (!isAdmin && managerId) {
    // Super gestore: rubrica dei gestori associati (sezione `users`) oltre alla
    // propria. Firestore `in` supporta max 10 valori → si limita per sicurezza.
    const visibleIds = getVisibleManagerIds(state, 'users');
    if (visibleIds.length > 1) {
      query = query.where('id_gestore', 'in', visibleIds.slice(0, 10));
    } else {
      query = query.where('id_gestore', '==', managerId);
    }
  }

  const unsubscribe = query.onSnapshot(
    (snapshot) => {
      const users = snapshot.docs.map((doc) => ({ id: doc.id, ...stripHistory(doc.data()) }));
      dispatch(usersActions.received(users.filter((e) => !e.deleted)));
    },
    (error) => {
      console.error('🔴 Firestore listener error (USERS):', error);
    }
  );

  dispatch(usersActions.listenerStarted(unsubscribe));
};

export const stopListeningUsers = () => (dispatch, getState) => {
  const unsubscribe = getState().users?.unsubscribe;
  if (unsubscribe) {
    unsubscribe();
    dispatch(usersActions.listenerStopped());
  }
};
